/*=========================================================================================
  File Name: courses.js
  Description: Vuex store for courses.
==========================================================================================*/
//imports
import axios from "axios";

// initial state
const state = {
  courses: [],
  course: {},
  courseRequests: [],
  switches: [],
  courseSwitches: [],
  depSwitches: [],
  switchesByCourse: [],
  trainings: [],
  currentCourseRequest: {},
  editableCourseRequest: {},
  deleted: [],
  contacts: [],
};

// getters
const getters = {
  getCourses: (state) => {
    return state.courses;
  },
  getCourse: (state) => {
    return state.course;
  },
  getTrainings: (state) => {
    return state.trainings;
  },
  getContacts: (state) => {
    return state.contacts;
  },
};

// actions
const actions = {
  fetchCourses({ commit }, all) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Courses/all/0/" + all)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_COURSES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Courses/" + payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_COURSE", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("api/courses/" + payload.courseId)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("DELETE_COURSE", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchTrainings({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Trainings")
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_TRAININGS", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  cancelCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put("api/courses/cancel/" + payload.id, payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("CANCEL_COURSE", payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchContactsByCompany({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Contacts/company/" + payload.companyId)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_CONTACTS", res.data);
        })
        .catch((err) => {
          commit("FETCH_CONTACTS", []);
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  FETCH_COURSE(state, data) {
    state.course = data;
  },
  FETCH_COURSES(state, data) {
    state.courses = data;
  },
  FETCH_TRAININGS(state, data) {
    state.trainings = data;
  },
  DELETE_COURSE(state, data) {
    let index = state.courses.findIndex((element) => element.id == data.id);
    state.courses.splice(index, 1);
  },
  FETCH_CONTACTS(state, data) {
    state.contacts = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
